<template lang='pug'>
.container-fluid.p-0.push-wrapper
  .container
    .row
      .col
        .row
          .col-12.my-header.font-weight-bold
            | Дизайн формы

  .container.mt-5
    .white_block
      .row
        .col(v-if="loading")
          .loader_holder
            object(type="image/svg+xml", data="/assets/loaders/infinity.svg")
      .row
        .col.shopSettings(v-if="!loading")
          .inputModule
            input-module(
              type="image",
              layout="square",
              title="Иконка страницы (favicon)",
              v-model="shopSettings.favicon",
              about="Мы рекомендуем изображение размером 64x64"
            )
          .inputModule
            input-module(
              type="image",
              title="Логотип на форме",
              v-model="shopSettings.logo",
              about="Мы рекомендуем изображение размером 600x200"
            )
          .inputModule
            input-module(
              type="image",
              layout="big",
              title="Задний фон формы",
              v-model="shopSettings.backgroundImage",
              about="Мы рекомендуем изображение размером 1000x1000"
            )
          .inputModule
            input-module(
              type="code-html",
              title="Дополнительный HTML-код",
              v-model="shopSettings.htmls",
              about="Например, вы можете установить пиксель на форму."
            )
          .inputModule
            input-module(
              type="code-css",
              title="Дополнительный CSS-код",
              v-model="shopSettings.styles",
              about="Например, вы можете самостаятельно изменить стиль элементов формы."
            )
          .inputModule
            input-module(
              type="code-js",
              title="Дополнительный JS-код",
              v-model="shopSettings.scripts",
              about="Например, вы можете добавить необходимый JS-код."
            )
          .inputModule
            input-module(
              type="cards-form-links",
              title="Ссылки на социальные сети",
              v-model="shopSettings.links"
            )
          .inputModule
            input-module(
              type="cards-form-shop-phone",
              title="Контакт заведения",
              v-model="shopSettings.links"
            )
          hr
          button.styled(v-on:click="saveSettings()") Сохранить
</template>
<script>
import { Tooltip } from "element-ui";
import moment from "moment";
import apiDriver from "../../apiDriver";

export default {
  components: {
    [Tooltip.name]: Tooltip,
  },

  data() {
    return {
      shopSettings: {},
      loading: true,
    };
  },

  computed: {},

  mounted() {
    this.loadShopSettings();
  },

  methods: {
    async handleImageUpload(e, model, text_key) {
      let img = e.target.files[0];
      model[text_key] = "Загрузка...";
      let formData = new FormData();
      formData.append("file", img);
      let upload = await apiDriver.upload.image(formData);
      if (!upload) {
        model[text_key] = "Произошла ошибка.";
        return;
      }
      model[text_key] = upload.upload.Location;
    },
    async loadShopSettings() {
      this.loading = true;
      let shopSettings = (
        await apiDriver.services.api.get("cards", "wallet/shopSettings")
      ).data;
      // shopSettings.settings.links = JSON.stringify(shopSettings.settings.links);
      // shopSettings.settings.i18n = JSON.stringify(shopSettings.settings.i18n);
      // shopSettings.settings.entry_places = JSON.stringify(shopSettings.settings.entry_places);
      delete shopSettings.settings.name;
      this.shopSettings = shopSettings.settings;
      this.loading = false;
    },
    async saveSettings() {
      this.$toast.success("Настройки успешно сохранены!");
      this.loading = true;
      let x = (
        await apiDriver.services.api.post(
          "cards",
          "wallet/shopSettings",
          this.shopSettings
        )
      ).data;
      this.loading = false;
    },
  },
};
</script>
<style scoped lang="stylus">
div {
  cursor: default;
}

.my-header {
  font-size: 26pt;
}

.header-pre-push {
  font-size: 1.5rem;
}

.header-push {
  font-size: 1.5rem;
  color: black;
}

.design {
  background: white;
}

.inputModule {
  margin-bottom: 10px;
}

.shopSettings {
  // background: white;
}
</style>
